module.exports = require('./helpers/bundle-url').getBundleURL('3NeWw') + "logo-dark.eefe0b7f.svg";